var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/.pnpm/papaparse@5.5.3/node_modules/papaparse/papaparse.min.js
var require_papaparse_min = __commonJS({
  "node_modules/.pnpm/papaparse@5.5.3/node_modules/papaparse/papaparse.min.js"(exports, module) {
    ((e2, t2) => {
      "function" == typeof define && define.amd ? define([], t2) : "object" == typeof module && "undefined" != typeof exports ? module.exports = t2() : e2.Papa = t2();
    })(exports, function r2() {
      var n2 = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n2 ? n2 : {};
      var d2, s = !n2.document && !!n2.postMessage, a2 = n2.IS_PAPA_WORKER || false, o2 = {}, h2 = 0, v = {};
      function u2(e2) {
        this._handle = null, this._finished = false, this._completed = false, this._halted = false, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = true, this._completeResults = { data: [], errors: [], meta: {} }, function(e3) {
          var t2 = b2(e3);
          t2.chunkSize = parseInt(t2.chunkSize), e3.step || e3.chunk || (t2.chunkSize = null);
          this._handle = new i2(t2), (this._handle.streamer = this)._config = t2;
        }.call(this, e2), this.parseChunk = function(t2, e3) {
          var i3 = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < i3) {
            let e4 = this._config.newline;
            e4 || (r3 = this._config.quoteChar || '"', e4 = this._handle.guessLineEndings(t2, r3)), t2 = [...t2.split(e4).slice(i3)].join(e4);
          }
          this.isFirstChunk && U2(this._config.beforeFirstChunk) && void 0 !== (r3 = this._config.beforeFirstChunk(t2)) && (t2 = r3), this.isFirstChunk = false, this._halted = false;
          var i3 = this._partialLine + t2, r3 = (this._partialLine = "", this._handle.parse(i3, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            t2 = r3.meta.cursor, i3 = (this._finished || (this._partialLine = i3.substring(t2 - this._baseIndex), this._baseIndex = t2), r3 && r3.data && (this._rowCount += r3.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
            if (a2) n2.postMessage({ results: r3, workerId: v.WORKER_ID, finished: i3 });
            else if (U2(this._config.chunk) && !e3) {
              if (this._config.chunk(r3, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = true);
              this._completeResults = r3 = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r3.data), this._completeResults.errors = this._completeResults.errors.concat(r3.errors), this._completeResults.meta = r3.meta), this._completed || !i3 || !U2(this._config.complete) || r3 && r3.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = true), i3 || r3 && r3.meta.paused || this._nextChunk(), r3;
          }
          this._halted = true;
        }, this._sendError = function(e3) {
          U2(this._config.error) ? this._config.error(e3) : a2 && this._config.error && n2.postMessage({ workerId: v.WORKER_ID, error: e3, finished: false });
        };
      }
      function f(e2) {
        var r3;
        (e2 = e2 || {}).chunkSize || (e2.chunkSize = v.RemoteChunkSize), u2.call(this, e2), this._nextChunk = s ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(e3) {
          this._input = e3, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (r3 = new XMLHttpRequest(), this._config.withCredentials && (r3.withCredentials = this._config.withCredentials), s || (r3.onload = y2(this._chunkLoaded, this), r3.onerror = y2(this._chunkError, this)), r3.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
              var e3, t2 = this._config.downloadRequestHeaders;
              for (e3 in t2) r3.setRequestHeader(e3, t2[e3]);
            }
            var i3;
            this._config.chunkSize && (i3 = this._start + this._config.chunkSize - 1, r3.setRequestHeader("Range", "bytes=" + this._start + "-" + i3));
            try {
              r3.send(this._config.downloadRequestBody);
            } catch (e4) {
              this._chunkError(e4.message);
            }
            s && 0 === r3.status && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          4 === r3.readyState && (r3.status < 200 || 400 <= r3.status ? this._chunkError() : (this._start += this._config.chunkSize || r3.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e3) => null !== (e3 = e3.getResponseHeader("Content-Range")) ? parseInt(e3.substring(e3.lastIndexOf("/") + 1)) : -1)(r3), this.parseChunk(r3.responseText)));
        }, this._chunkError = function(e3) {
          e3 = r3.statusText || e3;
          this._sendError(new Error(e3));
        };
      }
      function l2(e2) {
        (e2 = e2 || {}).chunkSize || (e2.chunkSize = v.LocalChunkSize), u2.call(this, e2);
        var i3, r3, n3 = "undefined" != typeof FileReader;
        this.stream = function(e3) {
          this._input = e3, r3 = e3.slice || e3.webkitSlice || e3.mozSlice, n3 ? ((i3 = new FileReader()).onload = y2(this._chunkLoaded, this), i3.onerror = y2(this._chunkError, this)) : i3 = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var e3 = this._input, t2 = (this._config.chunkSize && (t2 = Math.min(this._start + this._config.chunkSize, this._input.size), e3 = r3.call(e3, this._start, t2)), i3.readAsText(e3, this._config.encoding));
          n3 || this._chunkLoaded({ target: { result: t2 } });
        }, this._chunkLoaded = function(e3) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e3.target.result);
        }, this._chunkError = function() {
          this._sendError(i3.error);
        };
      }
      function c2(e2) {
        var i3;
        u2.call(this, e2 = e2 || {}), this.stream = function(e3) {
          return i3 = e3, this._nextChunk();
        }, this._nextChunk = function() {
          var e3, t2;
          if (!this._finished) return e3 = this._config.chunkSize, i3 = e3 ? (t2 = i3.substring(0, e3), i3.substring(e3)) : (t2 = i3, ""), this._finished = !i3, this.parseChunk(t2);
        };
      }
      function p2(e2) {
        u2.call(this, e2 = e2 || {});
        var t2 = [], i3 = true, r3 = false;
        this.pause = function() {
          u2.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          u2.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e3) {
          this._input = e3, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          r3 && 1 === t2.length && (this._finished = true);
        }, this._nextChunk = function() {
          this._checkIsFinished(), t2.length ? this.parseChunk(t2.shift()) : i3 = true;
        }, this._streamData = y2(function(e3) {
          try {
            t2.push("string" == typeof e3 ? e3 : e3.toString(this._config.encoding)), i3 && (i3 = false, this._checkIsFinished(), this.parseChunk(t2.shift()));
          } catch (e4) {
            this._streamError(e4);
          }
        }, this), this._streamError = y2(function(e3) {
          this._streamCleanUp(), this._sendError(e3);
        }, this), this._streamEnd = y2(function() {
          this._streamCleanUp(), r3 = true, this._streamData("");
        }, this), this._streamCleanUp = y2(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function i2(m3) {
        var n3, s2, a3, t2, o3 = Math.pow(2, 53), h3 = -o3, u3 = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d3 = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i3 = this, r3 = 0, f2 = 0, l3 = false, e2 = false, c3 = [], p3 = { data: [], errors: [], meta: {} };
        function y3(e3) {
          return "greedy" === m3.skipEmptyLines ? "" === e3.join("").trim() : 1 === e3.length && 0 === e3[0].length;
        }
        function g3() {
          if (p3 && a3 && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a3 = false), m3.skipEmptyLines && (p3.data = p3.data.filter(function(e4) {
            return !y3(e4);
          })), _3()) {
            let t4 = function(e4, t5) {
              U2(m3.transformHeader) && (e4 = m3.transformHeader(e4, t5)), c3.push(e4);
            };
            var t3 = t4;
            if (p3) if (Array.isArray(p3.data[0])) {
              for (var e3 = 0; _3() && e3 < p3.data.length; e3++) p3.data[e3].forEach(t4);
              p3.data.splice(0, 1);
            } else p3.data.forEach(t4);
          }
          function i4(e4, t4) {
            for (var i5 = m3.header ? {} : [], r5 = 0; r5 < e4.length; r5++) {
              var n4 = r5, s3 = e4[r5], s3 = ((e5, t5) => ((e6) => (m3.dynamicTypingFunction && void 0 === m3.dynamicTyping[e6] && (m3.dynamicTyping[e6] = m3.dynamicTypingFunction(e6)), true === (m3.dynamicTyping[e6] || m3.dynamicTyping)))(e5) ? "true" === t5 || "TRUE" === t5 || "false" !== t5 && "FALSE" !== t5 && (((e6) => {
                if (u3.test(e6)) {
                  e6 = parseFloat(e6);
                  if (h3 < e6 && e6 < o3) return 1;
                }
              })(t5) ? parseFloat(t5) : d3.test(t5) ? new Date(t5) : "" === t5 ? null : t5) : t5)(n4 = m3.header ? r5 >= c3.length ? "__parsed_extra" : c3[r5] : n4, s3 = m3.transform ? m3.transform(s3, n4) : s3);
              "__parsed_extra" === n4 ? (i5[n4] = i5[n4] || [], i5[n4].push(s3)) : i5[n4] = s3;
            }
            return m3.header && (r5 > c3.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c3.length + " fields but parsed " + r5, f2 + t4) : r5 < c3.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c3.length + " fields but parsed " + r5, f2 + t4)), i5;
          }
          var r4;
          p3 && (m3.header || m3.dynamicTyping || m3.transform) && (r4 = 1, !p3.data.length || Array.isArray(p3.data[0]) ? (p3.data = p3.data.map(i4), r4 = p3.data.length) : p3.data = i4(p3.data, 0), m3.header && p3.meta && (p3.meta.fields = c3), f2 += r4);
        }
        function _3() {
          return m3.header && 0 === c3.length;
        }
        function k(e3, t3, i4, r4) {
          e3 = { type: e3, code: t3, message: i4 };
          void 0 !== r4 && (e3.row = r4), p3.errors.push(e3);
        }
        U2(m3.step) && (t2 = m3.step, m3.step = function(e3) {
          p3 = e3, _3() ? g3() : (g3(), 0 !== p3.data.length && (r3 += e3.data.length, m3.preview && r3 > m3.preview ? s2.abort() : (p3.data = p3.data[0], t2(p3, i3))));
        }), this.parse = function(e3, t3, i4) {
          var r4 = m3.quoteChar || '"', r4 = (m3.newline || (m3.newline = this.guessLineEndings(e3, r4)), a3 = false, m3.delimiter ? U2(m3.delimiter) && (m3.delimiter = m3.delimiter(e3), p3.meta.delimiter = m3.delimiter) : ((r4 = ((e4, t4, i5, r5, n4) => {
            var s3, a4, o4, h4;
            n4 = n4 || [",", "	", "|", ";", v.RECORD_SEP, v.UNIT_SEP];
            for (var u4 = 0; u4 < n4.length; u4++) {
              for (var d4, f3 = n4[u4], l4 = 0, c4 = 0, p4 = 0, g4 = (o4 = void 0, new E2({ comments: r5, delimiter: f3, newline: t4, preview: 10 }).parse(e4)), _4 = 0; _4 < g4.data.length; _4++) i5 && y3(g4.data[_4]) ? p4++ : (d4 = g4.data[_4].length, c4 += d4, void 0 === o4 ? o4 = d4 : 0 < d4 && (l4 += Math.abs(d4 - o4), o4 = d4));
              0 < g4.data.length && (c4 /= g4.data.length - p4), (void 0 === a4 || l4 <= a4) && (void 0 === h4 || h4 < c4) && 1.99 < c4 && (a4 = l4, s3 = f3, h4 = c4);
            }
            return { successful: !!(m3.delimiter = s3), bestDelimiter: s3 };
          })(e3, m3.newline, m3.skipEmptyLines, m3.comments, m3.delimitersToGuess)).successful ? m3.delimiter = r4.bestDelimiter : (a3 = true, m3.delimiter = v.DefaultDelimiter), p3.meta.delimiter = m3.delimiter), b2(m3));
          return m3.preview && m3.header && r4.preview++, n3 = e3, s2 = new E2(r4), p3 = s2.parse(n3, t3, i4), g3(), l3 ? { meta: { paused: true } } : p3 || { meta: { paused: false } };
        }, this.paused = function() {
          return l3;
        }, this.pause = function() {
          l3 = true, s2.abort(), n3 = U2(m3.chunk) ? "" : n3.substring(s2.getCharIndex());
        }, this.resume = function() {
          i3.streamer._halted ? (l3 = false, i3.streamer.parseChunk(n3, true)) : setTimeout(i3.resume, 3);
        }, this.aborted = function() {
          return e2;
        }, this.abort = function() {
          e2 = true, s2.abort(), p3.meta.aborted = true, U2(m3.complete) && m3.complete(p3), n3 = "";
        }, this.guessLineEndings = function(e3, t3) {
          e3 = e3.substring(0, 1048576);
          var t3 = new RegExp(P(t3) + "([^]*?)" + P(t3), "gm"), i4 = (e3 = e3.replace(t3, "")).split("\r"), t3 = e3.split("\n"), e3 = 1 < t3.length && t3[0].length < i4[0].length;
          if (1 === i4.length || e3) return "\n";
          for (var r4 = 0, n4 = 0; n4 < i4.length; n4++) "\n" === i4[n4][0] && r4++;
          return r4 >= i4.length / 2 ? "\r\n" : "\r";
        };
      }
      function P(e2) {
        return e2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function E2(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I2 = C.step, A2 = C.preview, T2 = C.fastMode, D2 = null, L2 = false, F2 = null == C.quoteChar ? '"' : C.quoteChar, j2 = F2;
        if (void 0 !== C.escapeChar && (j2 = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        true === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = false), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z2 = 0, M2 = false;
        this.parse = function(i3, t2, r3) {
          if ("string" != typeof i3) throw new Error("Input must be a string");
          var n3 = i3.length, e2 = S.length, s2 = O.length, a3 = x.length, o3 = U2(I2), h3 = [], u3 = [], d3 = [], f2 = z2 = 0;
          if (!i3) return w2();
          if (T2 || false !== T2 && -1 === i3.indexOf(F2)) {
            for (var l3 = i3.split(O), c3 = 0; c3 < l3.length; c3++) {
              if (d3 = l3[c3], z2 += d3.length, c3 !== l3.length - 1) z2 += O.length;
              else if (r3) return w2();
              if (!x || d3.substring(0, a3) !== x) {
                if (o3) {
                  if (h3 = [], k(d3.split(S)), R2(), M2) return w2();
                } else k(d3.split(S));
                if (A2 && A2 <= c3) return h3 = h3.slice(0, A2), w2(true);
              }
            }
            return w2();
          }
          for (var p3 = i3.indexOf(S, z2), g3 = i3.indexOf(O, z2), _3 = new RegExp(P(j2) + P(F2), "g"), m3 = i3.indexOf(F2, z2); ; ) if (i3[z2] === F2) for (m3 = z2, z2++; ; ) {
            if (-1 === (m3 = i3.indexOf(F2, m3 + 1))) return r3 || u3.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: h3.length, index: z2 }), E3();
            if (m3 === n3 - 1) return E3(i3.substring(z2, m3).replace(_3, F2));
            if (F2 === j2 && i3[m3 + 1] === j2) m3++;
            else if (F2 === j2 || 0 === m3 || i3[m3 - 1] !== j2) {
              -1 !== p3 && p3 < m3 + 1 && (p3 = i3.indexOf(S, m3 + 1));
              var y3 = v2(-1 === (g3 = -1 !== g3 && g3 < m3 + 1 ? i3.indexOf(O, m3 + 1) : g3) ? p3 : Math.min(p3, g3));
              if (i3.substr(m3 + 1 + y3, e2) === S) {
                d3.push(i3.substring(z2, m3).replace(_3, F2)), i3[z2 = m3 + 1 + y3 + e2] !== F2 && (m3 = i3.indexOf(F2, z2)), p3 = i3.indexOf(S, z2), g3 = i3.indexOf(O, z2);
                break;
              }
              y3 = v2(g3);
              if (i3.substring(m3 + 1 + y3, m3 + 1 + y3 + s2) === O) {
                if (d3.push(i3.substring(z2, m3).replace(_3, F2)), b3(m3 + 1 + y3 + s2), p3 = i3.indexOf(S, z2), m3 = i3.indexOf(F2, z2), o3 && (R2(), M2)) return w2();
                if (A2 && h3.length >= A2) return w2(true);
                break;
              }
              u3.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: h3.length, index: z2 }), m3++;
            }
          }
          else if (x && 0 === d3.length && i3.substring(z2, z2 + a3) === x) {
            if (-1 === g3) return w2();
            z2 = g3 + s2, g3 = i3.indexOf(O, z2), p3 = i3.indexOf(S, z2);
          } else if (-1 !== p3 && (p3 < g3 || -1 === g3)) d3.push(i3.substring(z2, p3)), z2 = p3 + e2, p3 = i3.indexOf(S, z2);
          else {
            if (-1 === g3) break;
            if (d3.push(i3.substring(z2, g3)), b3(g3 + s2), o3 && (R2(), M2)) return w2();
            if (A2 && h3.length >= A2) return w2(true);
          }
          return E3();
          function k(e3) {
            h3.push(e3), f2 = z2;
          }
          function v2(e3) {
            var t3 = 0;
            return t3 = -1 !== e3 && (e3 = i3.substring(m3 + 1, e3)) && "" === e3.trim() ? e3.length : t3;
          }
          function E3(e3) {
            return r3 || (void 0 === e3 && (e3 = i3.substring(z2)), d3.push(e3), z2 = n3, k(d3), o3 && R2()), w2();
          }
          function b3(e3) {
            z2 = e3, k(d3), d3 = [], g3 = i3.indexOf(O, z2);
          }
          function w2(e3) {
            if (C.header && !t2 && h3.length && !L2) {
              var s3 = h3[0], a4 = /* @__PURE__ */ Object.create(null), o4 = new Set(s3);
              let n4 = false;
              for (let r4 = 0; r4 < s3.length; r4++) {
                let i4 = s3[r4];
                if (a4[i4 = U2(C.transformHeader) ? C.transformHeader(i4, r4) : i4]) {
                  let e4, t3 = a4[i4];
                  for (; e4 = i4 + "_" + t3, t3++, o4.has(e4); ) ;
                  o4.add(e4), s3[r4] = e4, a4[i4]++, n4 = true, (D2 = null === D2 ? {} : D2)[e4] = i4;
                } else a4[i4] = 1, s3[r4] = i4;
                o4.add(i4);
              }
              n4 && console.warn("Duplicate headers found and renamed."), L2 = true;
            }
            return { data: h3, errors: u3, meta: { delimiter: S, linebreak: O, aborted: M2, truncated: !!e3, cursor: f2 + (t2 || 0), renamedHeaders: D2 } };
          }
          function R2() {
            I2(w2()), h3 = [], u3 = [];
          }
        }, this.abort = function() {
          M2 = true;
        }, this.getCharIndex = function() {
          return z2;
        };
      }
      function g2(e2) {
        var t2 = e2.data, i3 = o2[t2.workerId], r3 = false;
        if (t2.error) i3.userError(t2.error, t2.file);
        else if (t2.results && t2.results.data) {
          var n3 = { abort: function() {
            r3 = true, _2(t2.workerId, { data: [], errors: [], meta: { aborted: true } });
          }, pause: m2, resume: m2 };
          if (U2(i3.userStep)) {
            for (var s2 = 0; s2 < t2.results.data.length && (i3.userStep({ data: t2.results.data[s2], errors: t2.results.errors, meta: t2.results.meta }, n3), !r3); s2++) ;
            delete t2.results;
          } else U2(i3.userChunk) && (i3.userChunk(t2.results, n3, t2.file), delete t2.results);
        }
        t2.finished && !r3 && _2(t2.workerId, t2.results);
      }
      function _2(e2, t2) {
        var i3 = o2[e2];
        U2(i3.userComplete) && i3.userComplete(t2), i3.terminate(), delete o2[e2];
      }
      function m2() {
        throw new Error("Not implemented.");
      }
      function b2(e2) {
        if ("object" != typeof e2 || null === e2) return e2;
        var t2, i3 = Array.isArray(e2) ? [] : {};
        for (t2 in e2) i3[t2] = b2(e2[t2]);
        return i3;
      }
      function y2(e2, t2) {
        return function() {
          e2.apply(t2, arguments);
        };
      }
      function U2(e2) {
        return "function" == typeof e2;
      }
      return v.parse = function(e2, t2) {
        var i3 = (t2 = t2 || {}).dynamicTyping || false;
        U2(i3) && (t2.dynamicTypingFunction = i3, i3 = {});
        if (t2.dynamicTyping = i3, t2.transform = !!U2(t2.transform) && t2.transform, !t2.worker || !v.WORKERS_SUPPORTED) return i3 = null, v.NODE_STREAM_INPUT, "string" == typeof e2 ? (e2 = ((e3) => 65279 !== e3.charCodeAt(0) ? e3 : e3.slice(1))(e2), i3 = new (t2.download ? f : c2)(t2)) : true === e2.readable && U2(e2.read) && U2(e2.on) ? i3 = new p2(t2) : (n2.File && e2 instanceof File || e2 instanceof Object) && (i3 = new l2(t2)), i3.stream(e2);
        (i3 = (() => {
          var e3;
          return !!v.WORKERS_SUPPORTED && (e3 = (() => {
            var e4 = n2.URL || n2.webkitURL || null, t3 = r2.toString();
            return v.BLOB_URL || (v.BLOB_URL = e4.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", t3, ")();"], { type: "text/javascript" })));
          })(), (e3 = new n2.Worker(e3)).onmessage = g2, e3.id = h2++, o2[e3.id] = e3);
        })()).userStep = t2.step, i3.userChunk = t2.chunk, i3.userComplete = t2.complete, i3.userError = t2.error, t2.step = U2(t2.step), t2.chunk = U2(t2.chunk), t2.complete = U2(t2.complete), t2.error = U2(t2.error), delete t2.worker, i3.postMessage({ input: e2, config: t2, workerId: i3.id });
      }, v.unparse = function(e2, t2) {
        var n3 = false, _3 = true, m3 = ",", y3 = "\r\n", s2 = '"', a3 = s2 + s2, i3 = false, r3 = null, o3 = false, h3 = ((() => {
          if ("object" == typeof t2) {
            if ("string" != typeof t2.delimiter || v.BAD_DELIMITERS.filter(function(e3) {
              return -1 !== t2.delimiter.indexOf(e3);
            }).length || (m3 = t2.delimiter), "boolean" != typeof t2.quotes && "function" != typeof t2.quotes && !Array.isArray(t2.quotes) || (n3 = t2.quotes), "boolean" != typeof t2.skipEmptyLines && "string" != typeof t2.skipEmptyLines || (i3 = t2.skipEmptyLines), "string" == typeof t2.newline && (y3 = t2.newline), "string" == typeof t2.quoteChar && (s2 = t2.quoteChar), "boolean" == typeof t2.header && (_3 = t2.header), Array.isArray(t2.columns)) {
              if (0 === t2.columns.length) throw new Error("Option columns is empty");
              r3 = t2.columns;
            }
            void 0 !== t2.escapeChar && (a3 = t2.escapeChar + s2), t2.escapeFormulae instanceof RegExp ? o3 = t2.escapeFormulae : "boolean" == typeof t2.escapeFormulae && t2.escapeFormulae && (o3 = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(P(s2), "g"));
        "string" == typeof e2 && (e2 = JSON.parse(e2));
        if (Array.isArray(e2)) {
          if (!e2.length || Array.isArray(e2[0])) return u3(null, e2, i3);
          if ("object" == typeof e2[0]) return u3(r3 || Object.keys(e2[0]), e2, i3);
        } else if ("object" == typeof e2) return "string" == typeof e2.data && (e2.data = JSON.parse(e2.data)), Array.isArray(e2.data) && (e2.fields || (e2.fields = e2.meta && e2.meta.fields || r3), e2.fields || (e2.fields = Array.isArray(e2.data[0]) ? e2.fields : "object" == typeof e2.data[0] ? Object.keys(e2.data[0]) : []), Array.isArray(e2.data[0]) || "object" == typeof e2.data[0] || (e2.data = [e2.data])), u3(e2.fields || [], e2.data || [], i3);
        throw new Error("Unable to serialize unrecognized input");
        function u3(e3, t3, i4) {
          var r4 = "", n4 = ("string" == typeof e3 && (e3 = JSON.parse(e3)), "string" == typeof t3 && (t3 = JSON.parse(t3)), Array.isArray(e3) && 0 < e3.length), s3 = !Array.isArray(t3[0]);
          if (n4 && _3) {
            for (var a4 = 0; a4 < e3.length; a4++) 0 < a4 && (r4 += m3), r4 += k(e3[a4], a4);
            0 < t3.length && (r4 += y3);
          }
          for (var o4 = 0; o4 < t3.length; o4++) {
            var h4 = (n4 ? e3 : t3[o4]).length, u4 = false, d3 = n4 ? 0 === Object.keys(t3[o4]).length : 0 === t3[o4].length;
            if (i4 && !n4 && (u4 = "greedy" === i4 ? "" === t3[o4].join("").trim() : 1 === t3[o4].length && 0 === t3[o4][0].length), "greedy" === i4 && n4) {
              for (var f2 = [], l3 = 0; l3 < h4; l3++) {
                var c3 = s3 ? e3[l3] : l3;
                f2.push(t3[o4][c3]);
              }
              u4 = "" === f2.join("").trim();
            }
            if (!u4) {
              for (var p3 = 0; p3 < h4; p3++) {
                0 < p3 && !d3 && (r4 += m3);
                var g3 = n4 && s3 ? e3[p3] : p3;
                r4 += k(t3[o4][g3], p3);
              }
              o4 < t3.length - 1 && (!i4 || 0 < h4 && !d3) && (r4 += y3);
            }
          }
          return r4;
        }
        function k(e3, t3) {
          var i4, r4;
          return null == e3 ? "" : e3.constructor === Date ? JSON.stringify(e3).slice(1, 25) : (r4 = false, o3 && "string" == typeof e3 && o3.test(e3) && (e3 = "'" + e3, r4 = true), i4 = e3.toString().replace(h3, a3), (r4 = r4 || true === n3 || "function" == typeof n3 && n3(e3, t3) || Array.isArray(n3) && n3[t3] || ((e4, t4) => {
            for (var i5 = 0; i5 < t4.length; i5++) if (-1 < e4.indexOf(t4[i5])) return true;
            return false;
          })(i4, v.BAD_DELIMITERS) || -1 < i4.indexOf(m3) || " " === i4.charAt(0) || " " === i4.charAt(i4.length - 1)) ? s2 + i4 + s2 : i4);
        }
      }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\uFEFF", v.BAD_DELIMITERS = ["\r", "\n", '"', v.BYTE_ORDER_MARK], v.WORKERS_SUPPORTED = !s && !!n2.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E2, v.ParserHandle = i2, v.NetworkStreamer = f, v.FileStreamer = l2, v.StringStreamer = c2, v.ReadableStreamStreamer = p2, n2.jQuery && ((d2 = n2.jQuery).fn.parse = function(o3) {
        var i3 = o3.config || {}, h3 = [];
        return this.each(function(e3) {
          if (!("INPUT" === d2(this).prop("tagName").toUpperCase() && "file" === d2(this).attr("type").toLowerCase() && n2.FileReader) || !this.files || 0 === this.files.length) return true;
          for (var t2 = 0; t2 < this.files.length; t2++) h3.push({ file: this.files[t2], inputElem: this, instanceConfig: d2.extend({}, i3) });
        }), e2(), this;
        function e2() {
          if (0 === h3.length) U2(o3.complete) && o3.complete();
          else {
            var e3, t2, i4, r3, n3 = h3[0];
            if (U2(o3.before)) {
              var s2 = o3.before(n3.file, n3.inputElem);
              if ("object" == typeof s2) {
                if ("abort" === s2.action) return e3 = "AbortError", t2 = n3.file, i4 = n3.inputElem, r3 = s2.reason, void (U2(o3.error) && o3.error({ name: e3 }, t2, i4, r3));
                if ("skip" === s2.action) return void u3();
                "object" == typeof s2.config && (n3.instanceConfig = d2.extend(n3.instanceConfig, s2.config));
              } else if ("skip" === s2) return void u3();
            }
            var a3 = n3.instanceConfig.complete;
            n3.instanceConfig.complete = function(e4) {
              U2(a3) && a3(e4, n3.file, n3.inputElem), u3();
            }, v.parse(n3.file, n3.instanceConfig);
          }
        }
        function u3() {
          h3.splice(0, 1), e2();
        }
      }), a2 && (n2.onmessage = function(e2) {
        e2 = e2.data;
        void 0 === v.WORKER_ID && e2 && (v.WORKER_ID = e2.workerId);
        "string" == typeof e2.input ? n2.postMessage({ workerId: v.WORKER_ID, results: v.parse(e2.input, e2.config), finished: true }) : (n2.File && e2.input instanceof File || e2.input instanceof Object) && (e2 = v.parse(e2.input, e2.config)) && n2.postMessage({ workerId: v.WORKER_ID, results: e2, finished: true });
      }), (f.prototype = Object.create(u2.prototype)).constructor = f, (l2.prototype = Object.create(u2.prototype)).constructor = l2, (c2.prototype = Object.create(c2.prototype)).constructor = c2, (p2.prototype = Object.create(u2.prototype)).constructor = p2, v;
    });
  }
});

// src/CSVParser.tsx
import { useState as useState2, useEffect } from "react";

// node_modules/.pnpm/zustand@5.0.6_@types+react@18.3.23_react@18.3.1/node_modules/zustand/esm/vanilla.mjs
var createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const api = { setState, getState, getInitialState, subscribe };
  const initialState = state = createState(setState, getState, api);
  return api;
};
var createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;

// node_modules/.pnpm/zustand@5.0.6_@types+react@18.3.23_react@18.3.1/node_modules/zustand/esm/react.mjs
import React from "react";
var identity = (arg) => arg;
function useStore(api, selector = identity) {
  const slice = React.useSyncExternalStore(
    api.subscribe,
    () => selector(api.getState()),
    () => selector(api.getInitialState())
  );
  React.useDebugValue(slice);
  return slice;
}
var createImpl = (createState) => {
  const api = createStore(createState);
  const useBoundStore = (selector) => useStore(api, selector);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
var create = (createState) => createState ? createImpl(createState) : createImpl;

// src/lib/reducer.ts
var useCSVStore = create()((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
  uploadedFile: void 0,
  setUploadedFile: (uploadedFile) => {
    const assignedCSVIndexes = uploadedFile?.results.data[0].map((_2, index) => ({
      index,
      selectedSchemaName: ""
    }));
    set({ uploadedFile, assignedCSVIndexes });
  },
  isOverwrite: false,
  setIsOverwrite: (isOverwrite) => set({ isOverwrite }),
  step: 1,
  setStep: (step) => set({ step }),
  importView: [],
  setImportView: (importView) => set({ importView }),
  categoryContext: null,
  setCategoryContext: (categoryContext) => set({ categoryContext }),
  assignedCSVIndexes: [],
  setAssignedCSVIndexes: (assignedCSVIndexes) => set({ assignedCSVIndexes }),
  changeAssignedCSVIndexes: (event, index) => set((state) => ({
    assignedCSVIndexes: state.assignedCSVIndexes.map((item) => item.index === index ? { ...item, selectedSchemaName: event.target.value } : item)
  })),
  assignedURLSlug: { indexOfCSV: 0 },
  setAssignedURLSlug: (assignedURLSlug) => set({ assignedURLSlug }),
  clearAll: () => set({
    uploadedFile: void 0,
    assignedURLSlug: { indexOfCSV: 0 },
    assignedCSVIndexes: [],
    isOverwrite: false,
    isNestedMode: false
  }),
  initializeCategoryContext: (categoryContext) => {
    set({ categoryContext });
  },
  isNestedMode: false,
  setIsNestedMode: (isNestedMode) => set({ isNestedMode }),
  assignedParentIdentifier: { indexOfCSV: 0 },
  assignedNestingIdentifier: { indexOfCSV: 1 },
  setAssignedParentIdentifier: (assignedParentIdentifier) => set({ assignedParentIdentifier }),
  setAssignedNestingIdentifier: (assignedNestingIdentifier) => set({ assignedNestingIdentifier })
}));

// src/lib/arrayToNestedCategories.ts
function arrayToNestedCategories(data, idIndex = 0, parentIndex = 1, urlSlugIndex = 0, assignedCSVIndexes) {
  const newData = data.slice(1);
  const nodeMap = /* @__PURE__ */ new Map();
  const rootNodes = [];
  newData.forEach((row) => {
    const schemaAttributes = {};
    assignedCSVIndexes.forEach(({ index, selectedSchemaName }) => {
      if (selectedSchemaName && index !== parentIndex) {
        schemaAttributes[selectedSchemaName] = row[index];
      }
    });
    const node = {
      category_value: {
        url_slug: row[urlSlugIndex].toLowerCase().replace(/([\W])/g, "-"),
        schema_attributes: schemaAttributes
      }
    };
    nodeMap.set(row[idIndex], node);
  });
  newData.forEach((row) => {
    const nodeId = row[idIndex];
    const parentId = row[parentIndex];
    const node = nodeMap.get(nodeId);
    if (parentId && nodeMap.has(parentId)) {
      const parent = nodeMap.get(parentId);
      if (parent && node) {
        if (!parent.children) {
          parent.children = {};
        }
        const childIndex = Object.keys(parent.children).length;
        parent.children[childIndex.toString()] = node;
      }
    } else if (node) {
      rootNodes.push(node);
    }
  });
  if (rootNodes.length === 0) {
    throw new Error("No root nodes found");
  }
  return rootNodes;
}

// src/lib/isValidJSONObject.ts
function isValidJSONObject(str) {
  if (typeof str !== "string") {
    return false;
  }
  try {
    const parsed = JSON.parse(str);
    return typeof parsed === "object" && parsed !== null;
  } catch (e2) {
    return false;
  }
}

// src/lib/schemaTypes.ts
var ALLOWED_TYPES = ["text", "formatted_text", "number", "date", "datetime", "form", "code", "checkbox", "dropdown", "category"];

// src/components/better-upload/BetterUpload.tsx
import { useState } from "react";

// node_modules/.pnpm/react-papaparse@4.4.0/node_modules/react-papaparse/dist/react-papaparse.es.js
var import_papaparse = __toESM(require_papaparse_min());
import n, { useState as t, useEffect as r, useMemo as o, useRef as i, useReducer as a, useCallback as c } from "react";
var u = function() {
  return u = Object.assign || function(e2) {
    for (var n2, t2 = 1, r2 = arguments.length; t2 < r2; t2++) for (var o2 in n2 = arguments[t2]) Object.prototype.hasOwnProperty.call(n2, o2) && (e2[o2] = n2[o2]);
    return e2;
  }, u.apply(this, arguments);
};
function l(e2, n2) {
  var t2 = {};
  for (var r2 in e2) Object.prototype.hasOwnProperty.call(e2, r2) && n2.indexOf(r2) < 0 && (t2[r2] = e2[r2]);
  if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
    var o2 = 0;
    for (r2 = Object.getOwnPropertySymbols(e2); o2 < r2.length; o2++) n2.indexOf(r2[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, r2[o2]) && (t2[r2[o2]] = e2[r2[o2]]);
  }
  return t2;
}
function d(e2, n2, t2) {
  if (t2 || 2 === arguments.length) for (var r2, o2 = 0, i2 = n2.length; o2 < i2; o2++) !r2 && o2 in n2 || (r2 || (r2 = Array.prototype.slice.call(n2, 0, o2)), r2[o2] = n2[o2]);
  return e2.concat(r2 || Array.prototype.slice.call(n2));
}
function p(e2) {
  var n2 = 1024, t2 = 1048576, r2 = 1073741824;
  if (e2 < t2) {
    var o2 = Number((e2 / n2).toFixed(0));
    return o2 <= 0 ? e2 + " B" : o2 + " KB";
  }
  return e2 < r2 ? (e2 / t2).toFixed(0) + " MB" : e2 < 1099511627776 ? (e2 / r2).toFixed(0) + " GB" : "";
}
function g(e2) {
  return "function" == typeof e2.isPropagationStopped ? e2.isPropagationStopped() : void 0 !== e2.cancelBubble && e2.cancelBubble;
}
function y() {
  for (var e2 = [], n2 = 0; n2 < arguments.length; n2++) e2[n2] = arguments[n2];
  return function(n3) {
    for (var t2 = [], r2 = 1; r2 < arguments.length; r2++) t2[r2 - 1] = arguments[r2];
    return e2.some(function(e3) {
      return !g(n3) && e3 && e3.apply(void 0, d([n3], t2, false)), g(n3);
    });
  };
}
function m(e2) {
  return e2.dataTransfer ? Array.prototype.some.call(e2.dataTransfer.types, function(e3) {
    return "Files" === e3 || "application/x-moz-file" === e3;
  }) : !!e2.target && !!e2.target.files;
}
var h = function(e2) {
  e2 = Array.isArray(e2) && 1 === e2.length ? e2[0] : e2;
  var n2 = Array.isArray(e2) ? "one of ".concat(e2.join(", ")) : e2;
  return { code: "file-invalid-type", message: "File type must be ".concat(n2) };
};
function b(e2, n2) {
  var t2 = "application/x-moz-file" === e2.type || function(e3, n3) {
    if (e3 && n3) {
      var t3 = Array.isArray(n3) ? n3 : n3.split(","), r2 = e3.name || "", o2 = (e3.type || "").toLowerCase(), i2 = o2.replace(/\/.*$/, "");
      return t3.some(function(e4) {
        var n4 = e4.trim().toLowerCase();
        return "." === n4.charAt(0) ? r2.toLowerCase().endsWith(n4) : n4.endsWith("/*") ? i2 === n4.replace(/\/.*$/, "") : o2 === n4;
      });
    }
    return true;
  }(e2, n2);
  return [t2, t2 ? null : h(n2)];
}
function w(e2) {
  return null != e2;
}
var D = function(e2) {
  return { code: "file-too-large", message: "File is larger than ".concat(e2, " bytes") };
};
var F = function(e2) {
  return { code: "file-too-small", message: "File is smaller than ".concat(e2, " bytes") };
};
var E = { code: "too-many-files", message: "Too many files" };
function B(e2) {
  e2.preventDefault();
}
var A = { progressBar: { borderRadius: 3, boxShadow: "inset 0 1px 3px rgba(0, 0, 0, .2)", bottom: 14, width: "100%" }, button: { position: "inherit", width: "100%" }, fill: { backgroundColor: "#659cef", borderRadius: 3, height: 10, transition: "width 500ms ease-in-out" } };
function L(e2) {
  var o2 = e2.style, i2 = e2.className, a2 = e2.display, c2 = t(0), u2 = c2[0], l2 = c2[1];
  return r(function() {
    l2(e2.percentage);
  }, [e2.percentage]), n.createElement("span", { style: Object.assign({}, A.progressBar, A.fill, o2, { width: "".concat(u2, "%"), display: a2 }), className: i2 });
}
function R(e2) {
  var t2 = e2.color, r2 = e2.width, o2 = void 0 === r2 ? 23 : r2, i2 = e2.height, a2 = void 0 === i2 ? 23 : i2;
  return n.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: o2, height: a2, viewBox: "0 0 512 512" }, n.createElement("path", { fill: t2, d: "M504.1 256C504.1 119 393 7.9 256 7.9S7.9 119 7.9 256 119 504.1 256 504.1 504.1 393 504.1 256z" }), n.createElement("path", { fill: "#FFF", d: "M285 256l72.5-84.2c7.9-9.2 6.9-23-2.3-31-9.2-7.9-23-6.9-30.9 2.3L256 222.4l-68.2-79.2c-7.9-9.2-21.8-10.2-31-2.3-9.2 7.9-10.2 21.8-2.3 31L227 256l-72.5 84.2c-7.9 9.2-6.9 23 2.3 31 4.1 3.6 9.2 5.3 14.3 5.3 6.2 0 12.3-2.6 16.6-7.6l68.2-79.2 68.2 79.2c4.3 5 10.5 7.6 16.6 7.6 5.1 0 10.2-1.7 14.3-5.3 9.2-7.9 10.2-21.8 2.3-31L285 256z" }));
}
var T = "text/csv, .csv, application/vnd.ms-excel";
function j() {
  var t2 = function(t3) {
    var s = t3.children, f = t3.accept, p2 = void 0 === f ? T : f, v = t3.config, h2 = void 0 === v ? {} : v, P = t3.minSize, x = void 0 === P ? 0 : P, O = t3.maxSize, S = void 0 === O ? 1 / 0 : O, k = t3.maxFiles, C = void 0 === k ? 1 : k, A2 = t3.disabled, j2 = void 0 !== A2 && A2, z2 = t3.noClick, N2 = void 0 !== z2 && z2, I2 = t3.noDrag, U2 = void 0 !== I2 && I2, _2 = t3.noDragEventsBubbling, q2 = void 0 !== _2 && _2, V2 = t3.noKeyboard, W = void 0 !== V2 && V2, G = t3.multiple, $ = void 0 !== G && G, H = t3.required, J = void 0 !== H && H, Q = t3.preventDropOnDocument, X = void 0 === Q || Q, Y = t3.onUploadAccepted, Z = t3.validator, ee = t3.onUploadRejected, ne = t3.onDragEnter, te = t3.onDragOver, re = t3.onDragLeave, oe = i(null), ie = i(null), ae = i([]), ce = a(M, K), ue = ce[0], le = ce[1], se = ue.acceptedFile, fe = ue.displayProgressBar, de = ue.progressBarPercentage, pe = ue.draggedFiles, ve = ue.isFileDialogActive, ge = function(e2) {
      ie.current && ie.current.contains(e2.target) || (e2.preventDefault(), ae.current = []);
    };
    r(function() {
      return X && (document.addEventListener("dragover", B, false), document.addEventListener("drop", ge, false)), function() {
        X && (document.removeEventListener("dragover", B), document.removeEventListener("drop", ge));
      };
    }, [ie, X]);
    var ye = function(e2) {
      return j2 ? null : e2;
    }, me = function(e2) {
      return U2 ? null : ye(e2);
    }, he = function(e2) {
      q2 && e2.stopPropagation();
    }, be = function(e2) {
      e2.preventDefault(e2), e2.persist(), he(e2);
    }, we = function(e2) {
      le({ displayProgressBar: e2, type: "setDisplayProgressBar" });
    }, De = function(e2) {
      le({ progressBarPercentage: e2, type: "setProgressBarPercentage" });
    }, Fe = function(e2) {
      return n.createElement(L, u({ display: fe, percentage: de }, e2));
    }, Ee = function(e2) {
      return n.createElement(R, u({}, e2));
    }, Be = c(function() {
      oe.current && ue.displayProgressBar && (le({ type: "openDialog" }), oe.current.value = null, oe.current.click());
    }, [le]), Pe = function() {
      ve && setTimeout(function() {
        oe.current && (oe.current.files.length || le({ type: "closeDialog" }));
      }, 300);
    };
    r(function() {
      return window.addEventListener("focus", Pe, false), function() {
        window.removeEventListener("focus", Pe, false);
      };
    }, [oe, ve]);
    var xe = c(function() {
      var e2;
      N2 || (void 0 === e2 && (e2 = window.navigator.userAgent), function(e3) {
        return -1 !== e3.indexOf("MSIE") || -1 !== e3.indexOf("Trident/");
      }(e2) || function(e3) {
        return -1 !== e3.indexOf("Edge/");
      }(e2) ? setTimeout(Be, 0) : Be());
    }, [oe, N2]), Oe = c(function(n2) {
      if (be(n2), De(0), ae.current = [], m(n2)) {
        if (g(n2) && !q2) return;
        var t4 = [], r2 = [], o2 = n2.target.files || n2.dataTransfer && n2.dataTransfer.files;
        if (Array.from(o2).forEach(function(e2) {
          var n3 = b(e2, p2), o3 = n3[0], i3 = n3[1], a3 = function(e3, n4, t5) {
            if (w(e3.size)) if (w(n4) && w(t5)) {
              if (e3.size > t5) return [false, D(t5)];
              if (e3.size < n4) return [false, F(n4)];
            } else {
              if (w(n4) && e3.size < n4) return [false, F(n4)];
              if (w(t5) && e3.size > t5) return [false, D(t5)];
            }
            return [true, null];
          }(e2, x, S), c3 = a3[0], u3 = a3[1], l3 = Z ? Z(e2) : null;
          if (o3 && c3 && !l3) t4.push(e2);
          else {
            var s3 = [i3, u3];
            l3 && (s3 = s3.concat(l3)), r2.push({ file: e2, errors: s3.filter(function(e3) {
              return e3;
            }) });
          }
        }), (!$ && t4.length > 1 || $ && C >= 1 && t4.length > C) && (t4.forEach(function(e2) {
          r2.push({ file: e2, errors: [E] });
        }), t4.splice(0)), le({ acceptedFiles: t4, fileRejections: r2, type: "setFiles" }), we("block"), r2.length > 0 && ee && ee(r2, n2), t4.length > 0 && Y) {
          var i2 = {}, a2 = [], c2 = [], u2 = [], l2 = new window.FileReader(), s2 = 0;
          t4.forEach(function(n3) {
            le({ acceptedFile: n3, type: "setFile" }), i2 = { complete: (null == h2 ? void 0 : h2.complete) || (null == h2 ? void 0 : h2.step) ? h2.complete : function() {
              Y({ data: a2, errors: c2, meta: u2 }, n3);
            }, step: (null == h2 ? void 0 : h2.step) ? h2.step : function(e2) {
              if (a2.push(e2.data), e2.errors.length > 0 && c2.push(e2.errors), e2.length > 0 && u2.push(e2[0].meta), h2 && h2.preview) {
                if (s2 = Math.round(a2.length / h2.preview * 100), a2.length === h2.preview) Y({ data: a2, errors: c2, meta: u2 }, n3);
              } else {
                var t5 = e2.meta.cursor, r3 = Math.round(t5 / n3.size * 100);
                if (r3 === s2) return;
                s2 = r3;
              }
              De(s2);
            } }, i2 = Object.assign({}, h2, i2), l2.onload = function(n4) {
              import_papaparse.default.parse(n4.target.result, i2);
            }, l2.onloadend = function() {
              setTimeout(function() {
                we("none");
              }, 2e3);
            }, l2.readAsText(n3, h2.encoding || "utf-8");
          });
        }
      }
    }, [$, p2, x, S, C, Z, Y]), Se = c(function(e2) {
      he(e2);
    }, []), ke = function(e2) {
      return W ? null : ye(e2);
    }, Ce = c(function(e2) {
      if (be(e2), ae.current = d(d([], ae.current, true), [e2.target], false), m(e2)) {
        if (g(e2) && !q2) return;
        le({ draggedFiles: pe, isDragActive: true, type: "setDraggedFiles" }), ne && ne(e2);
      }
    }, [ne, q2]), Ae = c(function(e2) {
      be(e2);
      var n2 = m(e2);
      if (n2 && e2.dataTransfer) try {
        e2.dataTransfer.dropEffect = "copy";
      } catch (e3) {
      }
      return n2 && te && te(e2), false;
    }, [te, q2]), Le = c(function(e2) {
      be(e2);
      var n2 = ae.current.filter(function(e3) {
        return ie.current && ie.current.contains(e3);
      }), t4 = n2.indexOf(e2.target);
      -1 !== t4 && n2.splice(t4, 1), ae.current = n2, n2.length > 0 || (le({ isDragActive: false, type: "setDraggedFiles", draggedFiles: [] }), m(e2) && re && re(e2));
    }, [ie, re, q2]), Re = c(function(e2) {
      ie.current && ie.current.isEqualNode(e2.target) && ("Space" !== e2.key && "Enter" !== e2.key || (e2.preventDefault(), Be()));
    }, [ie, oe]), Te = c(function() {
      le({ type: "focus" });
    }, []), je = c(function() {
      le({ type: "blur" });
    }, []), ze = o(function() {
      return function(e2) {
        void 0 === e2 && (e2 = {});
        var n2 = e2.onClick, t4 = void 0 === n2 ? function() {
        } : n2, r2 = e2.onDrop, o2 = void 0 === r2 ? function() {
        } : r2, i2 = e2.onDragOver, a2 = void 0 === i2 ? function() {
        } : i2, c2 = e2.onDragLeave, s2 = void 0 === c2 ? function() {
        } : c2, f2 = e2.onKeyDown, d2 = void 0 === f2 ? function() {
        } : f2, p3 = e2.onFocus, v2 = void 0 === p3 ? function() {
        } : p3, g2 = e2.onBlur, m2 = void 0 === g2 ? function() {
        } : g2, h3 = e2.onDragEnter, b2 = void 0 === h3 ? function() {
        } : h3, w2 = l(e2, ["onClick", "onDrop", "onDragOver", "onDragLeave", "onKeyDown", "onFocus", "onBlur", "onDragEnter"]);
        return u({ onClick: ye(y(t4, xe)), onDrop: me(y(o2, Oe)), onDragEnter: me(y(b2, Ce)), onDragOver: me(y(a2, Ae)), onDragLeave: me(y(s2, Le)), onKeyDown: ke(y(d2, Re)), onFocus: ke(y(v2, Te)), onBlur: ke(y(m2, je)) }, w2);
      };
    }, [ie, Re, Te, je, xe, Ce, Ae, Le, Oe, W, U2, j2]), Ke = o(function() {
      return function(e2) {
        var n2;
        void 0 === e2 && (e2 = {});
        var t4 = e2.refKey, r2 = void 0 === t4 ? "ref" : t4, o2 = e2.onChange, i2 = void 0 === o2 ? function() {
        } : o2, a2 = e2.onClick, c2 = void 0 === a2 ? function() {
        } : a2, s2 = l(e2, ["refKey", "onChange", "onClick"]), f2 = ((n2 = { accept: p2, multiple: $, required: J, type: "file", style: { display: "none" }, onChange: ye(y(i2, Oe)), onClick: ye(y(c2, Se)), autoComplete: "off", tabIndex: -1 })[r2] = oe, n2);
        return u(u({}, f2), s2);
      };
    }, [oe, p2, Oe, j2]), Me = c(function(e2) {
      oe.current.value = "", le({ type: "reset" }), e2.stopPropagation();
    }, []), Ne = o(function() {
      return function(e2) {
        void 0 === e2 && (e2 = {});
        var n2 = e2.onClick, t4 = void 0 === n2 ? function() {
        } : n2, r2 = l(e2, ["onClick"]);
        return u({ onClick: ye(y(t4, Me)) }, r2);
      };
    }, [Me]);
    return n.createElement(n.Fragment, null, n.createElement("input", u({}, Ke())), s({ getRootProps: ze, acceptedFile: se, ProgressBar: Fe, getRemoveFileProps: Ne, Remove: Ee }));
  };
  return o(function() {
    return t2;
  }, []);
}
function z() {
  return { CSVReader: j() };
}
var K = { displayProgressBar: "none", progressBarPercentage: 0, isDragActive: false, isFileDialogActive: false, isFocused: false, draggedFiles: [], acceptedFiles: [], acceptedFile: null };
function M(e2, n2) {
  switch (n2.type) {
    case "openDialog":
      return u(u({}, e2), { isFileDialogActive: true });
    case "closeDialog":
      return u(u({}, e2), { isFileDialogActive: false });
    case "setFiles":
      return u(u({}, e2), { acceptedFiles: n2.acceptedFiles, fileRejections: n2.fileRejections });
    case "setFile":
      return u(u({}, e2), { acceptedFile: n2.acceptedFile });
    case "setDisplayProgressBar":
      return u(u({}, e2), { displayProgressBar: n2.displayProgressBar });
    case "setProgressBarPercentage":
      return u(u({}, e2), { progressBarPercentage: n2.progressBarPercentage });
    case "setDraggedFiles":
      var t2 = n2.isDragActive, r2 = n2.draggedFiles;
      return u(u({}, e2), { draggedFiles: r2, isDragActive: t2 });
    case "focus":
      return u(u({}, e2), { isFocused: true });
    case "blur":
      return u(u({}, e2), { isFocused: false });
    case "reset":
      return u({}, K);
    default:
      return e2;
  }
}
var N = import_papaparse.default.BAD_DELIMITERS;
var I = import_papaparse.default.RECORD_SEP;
var U = import_papaparse.default.UNIT_SEP;
var _ = import_papaparse.default.WORKERS_SUPPORTED;
var q = import_papaparse.default.LocalChunkSize;
var V = import_papaparse.default.DefaultDelimiter;

// src/components/better-upload/BetterUpload.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var GREY = "#CCC";
var GREY_DIM = "#686868";
var styles = {
  zone: {
    alignItems: "center",
    border: `2px dashed ${GREY}`,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    minHeight: 220,
    justifyContent: "center",
    padding: 20
  },
  file: {
    background: "linear-gradient(to bottom, #261E43, #483E6E)",
    borderRadius: 20,
    display: "flex",
    height: 160,
    width: 160,
    position: "relative",
    zIndex: 10,
    flexDirection: "column",
    justifyContent: "center"
  },
  info: {
    alignItems: "center",
    color: "white",
    display: "flex",
    flexDirection: "column",
    paddingLeft: 10,
    paddingRight: 10
  },
  size: {
    backgroundColor: "transparent",
    borderRadius: 3,
    marginBottom: "0.5em",
    justifyContent: "center",
    display: "flex"
  },
  name: {
    backgroundColor: "transparent",
    borderRadius: 3,
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: "0.5em"
  },
  progressBar: {
    bottom: 14,
    position: "absolute",
    width: "80%",
    paddingLeft: "10%",
    paddingRight: "10%"
  },
  zoneHover: {
    border: `2px dashed ${GREY_DIM}`
  },
  default: {
    border: `2px dashed ${GREY}`
  },
  remove: {
    position: "absolute",
    right: 6,
    top: 6
  }
};
function BetterUpload() {
  const [zoneHover, setZoneHover] = useState(false);
  const { uploadedFile, setUploadedFile, clearAll } = useCSVStore();
  const { CSVReader } = z();
  return /* @__PURE__ */ jsx(
    CSVReader,
    {
      onUploadAccepted: (results, file) => {
        setUploadedFile({ results, file });
        setZoneHover(false);
      },
      onDragOver: (event) => {
        event.preventDefault();
        setZoneHover(true);
      },
      onDragLeave: (event) => {
        event.preventDefault();
        setZoneHover(false);
      },
      children: ({ getRootProps, getRemoveFileProps }) => /* @__PURE__ */ jsx("div", { ...getRootProps(), style: Object.assign({}, styles.zone, zoneHover && styles.zoneHover), children: uploadedFile ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { style: styles.file, children: [
        /* @__PURE__ */ jsxs("div", { style: styles.info, children: [
          /* @__PURE__ */ jsx("span", { style: styles.size, children: p(uploadedFile.file.size) }),
          /* @__PURE__ */ jsx("span", { style: styles.name, children: uploadedFile.file.name })
        ] }),
        /* @__PURE__ */ jsx("div", { ...getRemoveFileProps(), style: styles.remove, "data-bs-theme": "dark", children: /* @__PURE__ */ jsx("button", { type: "button", className: "btn-close btn-close-white", onClick: clearAll }) })
      ] }) }) : /* @__PURE__ */ jsxs("span", { children: [
        "Drop CSV file here or ",
        /* @__PURE__ */ jsx("b", { children: "click to upload." })
      ] }) })
    }
  );
}

// node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t2 = arguments[e2];
      for (var r2 in t2) ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends.apply(null, arguments);
}

// node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e2) {
  if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e2;
}

// node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t2, e2) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e3) {
    return t3.__proto__ = e3, t3;
  }, _setPrototypeOf(t2, e2);
}

// node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(t2, o2) {
  t2.prototype = Object.create(o2.prototype), t2.prototype.constructor = t2, _setPrototypeOf(t2, o2);
}

// node_modules/.pnpm/memoize-one@5.2.1/node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i2 = 0; i2 < newInputs.length; i2++) {
    if (!isEqual(newInputs[i2], lastInputs[i2])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual2(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
var memoize_one_esm_default = memoizeOne;

// node_modules/.pnpm/react-window@1.8.11_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-window/dist/index.esm.js
import { createElement, PureComponent } from "react";
var hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var now = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();
  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }
  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var size = -1;
function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (size === -1 || recalculate) {
    var div = document.createElement("div");
    var style = div.style;
    style.width = "50px";
    style.height = "50px";
    style.overflow = "scroll";
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement("div");
    var outerStyle = outerDiv.style;
    outerStyle.width = "50px";
    outerStyle.height = "50px";
    outerStyle.overflow = "scroll";
    outerStyle.direction = "rtl";
    var innerDiv = document.createElement("div");
    var innerStyle = innerDiv.style;
    innerStyle.width = "100px";
    innerStyle.height = "100px";
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);
    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = "positive-descending";
    } else {
      outerDiv.scrollLeft = 1;
      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = "negative";
      } else {
        cachedRTLResult = "positive-ascending";
      }
    }
    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }
  return cachedRTLResult;
}
var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;
if (true) {
  if (typeof window !== "undefined" && typeof window.WeakSet !== "undefined") {
    devWarningsOverscanCount = /* @__PURE__ */ new WeakSet();
    devWarningsOverscanRowsColumnsCount = /* @__PURE__ */ new WeakSet();
    devWarningsTagName = /* @__PURE__ */ new WeakSet();
  }
}
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
};
var devWarningsDirection = null;
var devWarningsTagName$1 = null;
if (true) {
  if (typeof window !== "undefined" && typeof window.WeakSet !== "undefined") {
    devWarningsDirection = /* @__PURE__ */ new WeakSet();
    devWarningsTagName$1 = /* @__PURE__ */ new WeakSet();
  }
}
function createListComponent(_ref) {
  var _class;
  var getItemOffset2 = _ref.getItemOffset, getEstimatedTotalSize2 = _ref.getEstimatedTotalSize, getItemSize2 = _ref.getItemSize, getOffsetForIndexAndAlignment2 = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset2 = _ref.getStartIndexForOffset, getStopIndexForStartIndex2 = _ref.getStopIndexForStartIndex, initInstanceProps2 = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps2 = _ref.validateProps;
  return _class = /* @__PURE__ */ function(_PureComponent) {
    _inheritsLoose(List, _PureComponent);
    function List(props) {
      var _this;
      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps2(_this.props, _assertThisInitialized(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        scrollDirection: "forward",
        scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoize_one_esm_default(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex,
          overscanStopIndex,
          visibleStartIndex,
          visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoize_one_esm_default(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection,
          scrollOffset,
          scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;
      _this._getItemStyle = function(index) {
        var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
        var style;
        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset2(_this.props, index, _this._instanceProps);
          var size2 = getItemSize2(_this.props, index, _this._instanceProps);
          var isHorizontal = direction === "horizontal" || layout === "horizontal";
          var isRtl = direction === "rtl";
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: "absolute",
            left: isRtl ? void 0 : offsetHorizontal,
            right: isRtl ? offsetHorizontal : void 0,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size2 : "100%",
            width: isHorizontal ? size2 : "100%"
          };
        }
        return style;
      };
      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoize_one_esm_default(function(_2, __, ___) {
        return {};
      });
      _this._onScrollHorizontal = function(event) {
        var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
        _this.setState(function(prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            return null;
          }
          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                scrollOffset = -scrollLeft;
                break;
              case "positive-descending":
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          }
          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
            scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._onScrollVertical = function(event) {
        var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
        _this.setState(function(prevState) {
          if (prevState.scrollOffset === scrollTop) {
            return null;
          }
          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
            scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._outerRefSetter = function(ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;
        if (typeof outerRef === "function") {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) {
          outerRef.current = ref;
        }
      };
      _this._resetIsScrollingDebounced = function() {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }
        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };
      _this._resetIsScrolling = function() {
        _this._resetIsScrollingTimeoutId = null;
        _this.setState({
          isScrolling: false
        }, function() {
          _this._getItemStyleCache(-1, null);
        });
      };
      return _this;
    }
    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps2(nextProps);
      return null;
    };
    var _proto = List.prototype;
    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function(prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }
        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
          scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };
    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = "auto";
      }
      var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      var scrollbarSize = 0;
      if (this._outerRef) {
        var outerRef = this._outerRef;
        if (layout === "vertical") {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }
      this.scrollTo(getOffsetForIndexAndAlignment2(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
      if (typeof initialScrollOffset === "number" && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "horizontal" || layout === "horizontal") {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
      var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "horizontal" || layout === "horizontal") {
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                outerRef.scrollLeft = -scrollOffset;
                break;
              case "positive-ascending":
                outerRef.scrollLeft = scrollOffset;
                break;
              default:
                var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };
    _proto.render = function render() {
      var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
      var isScrolling = this.state.isScrolling;
      var isHorizontal = direction === "horizontal" || layout === "horizontal";
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
      var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
      var items = [];
      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : void 0,
            style: this._getItemStyle(_index)
          }));
        }
      }
      var estimatedTotalSize = getEstimatedTotalSize2(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || "div", {
        className,
        onScroll,
        ref: this._outerRefSetter,
        style: _extends({
          position: "relative",
          height,
          width,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction
        }, style)
      }, createElement(innerElementType || innerTagName || "div", {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? "100%" : estimatedTotalSize,
          pointerEvents: isScrolling ? "none" : void 0,
          width: isHorizontal ? estimatedTotalSize : "100%"
        }
      }));
    };
    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === "function") {
        var itemCount = this.props.itemCount;
        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }
      if (typeof this.props.onScroll === "function") {
        var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    };
    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }
      var startIndex = getStartIndexForOffset2(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex2(this.props, startIndex, scrollOffset, this._instanceProps);
      var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };
    return List;
  }(PureComponent), _class.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
}
var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
  var instance = _ref3.instance;
  if (true) {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead.");
      }
    }
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    switch (direction) {
      case "horizontal":
      case "vertical":
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + direction + '" was specified.'));
    }
    switch (layout) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + layout + '" was specified.'));
    }
    if (children == null) {
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (children === null ? "null" : typeof children) + '" was specified.'));
    }
    if (isHorizontal && typeof width !== "number") {
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (width === null ? "null" : typeof width) + '" was specified.'));
    } else if (!isHorizontal && typeof height !== "number") {
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (height === null ? "null" : typeof height) + '" was specified.'));
    }
  }
};
var FixedSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var size2 = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size2);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size2 + itemSize + scrollbarSize);
    if (align === "smart") {
      if (scrollOffset >= minOffset - size2 && scrollOffset <= maxOffset + size2) {
        align = "auto";
      } else {
        align = "center";
      }
    }
    switch (align) {
      case "start":
        return maxOffset;
      case "end":
        return minOffset;
      case "center": {
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
        if (middleOffset < Math.ceil(size2 / 2)) {
          return 0;
        } else if (middleOffset > lastItemOffset + Math.floor(size2 / 2)) {
          return lastItemOffset;
        } else {
          return middleOffset;
        }
      }
      case "auto":
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var offset = startIndex * itemSize;
    var size2 = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size2 + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(
      itemCount - 1,
      startIndex + numVisibleItems - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;
    if (true) {
      if (typeof itemSize !== "number") {
        throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (itemSize === null ? "null" : typeof itemSize) + '" was specified.'));
      }
    }
  }
});

// src/components/steps/StepOne.tsx
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var LEFT_WIDTH = 120;
var COLUMN_WIDTH = 350;
var Row = ({ index, style, field }) => /* @__PURE__ */ jsxs2("div", { style, className: "d-flex w-100", children: [
  /* @__PURE__ */ jsx2("div", { className: "border", style: { width: LEFT_WIDTH }, children: index + 1 }),
  field.map((value, i2) => /* @__PURE__ */ jsx2("div", { className: "border", style: { width: COLUMN_WIDTH }, children: /* @__PURE__ */ jsx2(
    "span",
    {
      style: {
        display: "block",
        width: 220,
        height: 45,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      },
      children: value
    }
  ) }, i2))
] });
function StepOne() {
  const {
    uploadedFile,
    categoryContext,
    assignedCSVIndexes,
    changeAssignedCSVIndexes,
    isNestedMode,
    assignedNestingIdentifier,
    setAssignedNestingIdentifier,
    assignedParentIdentifier,
    setAssignedParentIdentifier
  } = useCSVStore();
  const categorySchemaOptions = categoryContext?.schema;
  const headers = uploadedFile?.results.data[0];
  const length = headers?.length;
  return /* @__PURE__ */ jsxs2("div", { className: "card", style: { overflow: "auto", width: "100%", height: 700 }, children: [
    /* @__PURE__ */ jsxs2("div", { className: "d-flex flex-column", style: { width: length ? length * COLUMN_WIDTH + LEFT_WIDTH : LEFT_WIDTH }, children: [
      /* @__PURE__ */ jsxs2("div", { className: "d-flex w-100", children: [
        /* @__PURE__ */ jsx2("div", { className: "border d-flex justify-content-center align-items-center", style: { width: LEFT_WIDTH }, children: "Assign to:" }),
        headers?.map((field, index) => /* @__PURE__ */ jsx2("div", { className: "border p-2", style: { width: COLUMN_WIDTH }, children: /* @__PURE__ */ jsxs2("select", { className: "form-select", onChange: (event) => changeAssignedCSVIndexes(event, index), children: [
          /* @__PURE__ */ jsx2("option", { value: "", children: "(none)" }),
          categorySchemaOptions?.map((option, index2) => /* @__PURE__ */ jsx2("option", { value: option.name, disabled: assignedCSVIndexes.some((each) => each.selectedSchemaName === option.name), children: option.name }, index2))
        ] }) }, `${field}-${index}`))
      ] }),
      /* @__PURE__ */ jsxs2("div", { className: "d-flex w-100", children: [
        /* @__PURE__ */ jsx2("div", { className: "border", style: { textAlign: "center", verticalAlign: "middle", width: LEFT_WIDTH }, children: "Your CSV File Headers:" }),
        headers?.map((field, index) => /* @__PURE__ */ jsx2(
          "b",
          {
            className: "border d-flex justify-content-center align-items-center",
            style: { textAlign: "center", verticalAlign: "middle", width: COLUMN_WIDTH },
            children: field
          },
          index
        ))
      ] }),
      !!isNestedMode && /* @__PURE__ */ jsxs2(Fragment2, { children: [
        /* @__PURE__ */ jsxs2("div", { className: "d-flex w-100", children: [
          /* @__PURE__ */ jsx2("div", { className: "border", style: { textAlign: "center", verticalAlign: "middle", width: LEFT_WIDTH }, children: "Select parent identifier column:" }),
          headers?.map((field, index) => /* @__PURE__ */ jsx2(
            "div",
            {
              className: "border d-flex justify-content-center align-items-center",
              style: { textAlign: "center", verticalAlign: "middle", width: COLUMN_WIDTH },
              children: assignedNestingIdentifier.indexOfCSV !== index ? /* @__PURE__ */ jsx2(
                "input",
                {
                  className: "form-check-input",
                  type: "checkbox",
                  id: "overwrite-selector",
                  checked: assignedParentIdentifier.indexOfCSV === index,
                  onChange: () => setAssignedParentIdentifier({ indexOfCSV: index })
                }
              ) : /* @__PURE__ */ jsx2("span", { className: "text-muted", children: "Can't choose parent identifier to be same as nesting identifier." })
            },
            index
          ))
        ] }),
        /* @__PURE__ */ jsxs2("div", { className: "d-flex w-100", children: [
          /* @__PURE__ */ jsx2("div", { className: "border", style: { textAlign: "center", verticalAlign: "middle", width: LEFT_WIDTH }, children: "Select nesting identifier column:" }),
          headers?.map((field, index) => /* @__PURE__ */ jsx2(
            "div",
            {
              className: "border d-flex justify-content-center align-items-center",
              style: { textAlign: "center", verticalAlign: "middle", width: COLUMN_WIDTH },
              children: assignedParentIdentifier.indexOfCSV !== index ? /* @__PURE__ */ jsx2(
                "input",
                {
                  className: "form-check-input",
                  type: "checkbox",
                  id: "overwrite-selector",
                  checked: assignedNestingIdentifier.indexOfCSV === index,
                  onChange: () => setAssignedNestingIdentifier({ indexOfCSV: index })
                }
              ) : /* @__PURE__ */ jsx2("span", { className: "text-muted", children: "Can't choose nesting identifier to be same as the parent identifier" })
            },
            index
          ))
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx2(
      FixedSizeList,
      {
        itemData: uploadedFile?.results.data.slice(1),
        itemCount: uploadedFile?.results.data.length ? uploadedFile.results.data.length - 1 : 0,
        itemSize: 50,
        height: 580,
        width: length ? length * COLUMN_WIDTH + LEFT_WIDTH : LEFT_WIDTH,
        children: ({ index, style, data }) => /* @__PURE__ */ jsx2(Row, { index, style, field: data[index] })
      }
    )
  ] });
}

// src/components/steps/StepTwo.tsx
import React2 from "react";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
function StepTwo() {
  const { isLoading, importView } = useCSVStore();
  return /* @__PURE__ */ jsx3(
    "div",
    {
      className: "card",
      style: {
        width: "100%",
        overflow: "scroll",
        paddingTop: "2rem",
        paddingBottom: "2rem",
        paddingLeft: "1rem"
      },
      children: isLoading ? /* @__PURE__ */ jsx3("div", { className: "spinner-border", role: "status", children: /* @__PURE__ */ jsx3("span", { className: "visually-hidden", children: "Loading..." }) }) : /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsx3("ol", { children: importView.map((each, index) => /* @__PURE__ */ jsxs3(React2.Fragment, { children: [
        /* @__PURE__ */ jsx3("li", { children: each.action ? /* @__PURE__ */ jsxs3("div", { children: [
          /* @__PURE__ */ jsxs3("span", { children: [
            "\u2705 Successfully ",
            /* @__PURE__ */ jsxs3("b", { children: [
              each.action,
              "d"
            ] }),
            ": ",
            /* @__PURE__ */ jsx3("br", {})
          ] }),
          Object.entries(each["category_value"]["schema_attributes"]).map(([key, value], index2) => /* @__PURE__ */ jsxs3("span", { children: [
            key,
            ": ",
            /* @__PURE__ */ jsxs3("code", { children: [
              " ",
              JSON.stringify(value),
              " "
            ] })
          ] }, index2))
        ] }) : each.error && /* @__PURE__ */ jsxs3("label", { children: [
          "\u274C ",
          /* @__PURE__ */ jsxs3("code", { children: [
            "Error occured on entry: ",
            index + 1
          ] }),
          " | ",
          /* @__PURE__ */ jsxs3("span", { children: [
            /* @__PURE__ */ jsx3("b", { children: JSON.stringify(each.error.description) }),
            " | ",
            JSON.stringify(each.error.details[0])
          ] })
        ] }) }),
        each.save_children_status && /* @__PURE__ */ jsx3("div", { className: "d-flex flex-column gap-2", children: Object.entries(each.save_children_status).map(([key, status], index2) => /* @__PURE__ */ jsx3("li", { children: /* @__PURE__ */ jsxs3("span", { children: [
          status.action === "error" ? "\u274C" : "\u2705",
          " ",
          key,
          ":",
          " ",
          /* @__PURE__ */ jsxs3("code", { children: [
            status.action,
            " | ",
            status.message,
            " "
          ] })
        ] }) }, index2)) })
      ] }, index)) }) })
    }
  );
}

// src/components/url-slug-selector/URLSlugSelector.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
function URLSlugSelector() {
  const { uploadedFile, categoryContext, setAssignedURLSlug } = useCSVStore();
  return /* @__PURE__ */ jsxs4("div", { children: [
    /* @__PURE__ */ jsxs4("div", { className: "mb-2", children: [
      /* @__PURE__ */ jsx4("label", { className: "mb-1", children: "Select URL Slug" }),
      /* @__PURE__ */ jsxs4("select", { onChange: (e2) => setAssignedURLSlug({ indexOfCSV: e2.target.value }), className: "form-select", children: [
        /* @__PURE__ */ jsx4("option", { value: "", children: "(none)" }),
        uploadedFile?.results.data[0].map((field, index) => /* @__PURE__ */ jsx4("option", { value: index, children: field }, `${field}-${index}th-option`))
      ] })
    ] }),
    /* @__PURE__ */ jsxs4("p", { className: "text-muted mb-0", children: [
      'If (none) is selected, the identifier: "',
      categoryContext?.identifier,
      '" will be chosen as the URL Slug'
    ] })
  ] });
}

// src/components/is-nested-toggler/ISNestedToggler.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
function ISNestedToggler() {
  const { isNestedMode, setIsNestedMode } = useCSVStore();
  return /* @__PURE__ */ jsxs5("div", { children: [
    /* @__PURE__ */ jsxs5("div", { className: "form-check", children: [
      /* @__PURE__ */ jsx5("input", { className: "form-check-input", type: "checkbox", id: "overwrite-selector", onChange: () => setIsNestedMode(!isNestedMode) }),
      /* @__PURE__ */ jsx5("label", { className: "form-check-label muted", htmlFor: "flexCheckDefault", children: "Enable Nested Mode?" })
    ] }),
    /* @__PURE__ */ jsx5("div", { className: "d-flex flex-column gap-2", children: /* @__PURE__ */ jsxs5("p", { className: "text-muted mb-0", children: [
      "Nested mode requires you to select two columns, one for the parent value ",
      /* @__PURE__ */ jsx5("br", {}),
      "based on the value at that cell, and the other for ",
      /* @__PURE__ */ jsx5("b", { children: "identifying" }),
      " the parent value ",
      /* @__PURE__ */ jsx5("br", {}),
      " based on the value at that cell."
    ] }) })
  ] });
}

// src/CSVParser.tsx
import "bootstrap/dist/css/bootstrap.min.css";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var commonStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%"
};
var CSVParser = (props) => {
  const { category, url } = props;
  const { id: categoryID } = category;
  const {
    initializeCategoryContext,
    setIsLoading,
    uploadedFile,
    step,
    setStep,
    setImportView,
    isOverwrite,
    setIsOverwrite,
    categoryContext,
    assignedCSVIndexes,
    assignedURLSlug,
    isNestedMode,
    assignedParentIdentifier,
    assignedNestingIdentifier
  } = useCSVStore();
  const [error, setError] = useState2(null);
  const useForPages = categoryContext?.has_template;
  const isNested = categoryContext?.is_nested;
  const schema = categoryContext?.schema;
  const validateRow = (row, index) => {
    if (!row.some(Boolean)) {
      throw new Error(`No values are found on row ${index + 1} of the file`);
    }
  };
  const processRowData = (row, index) => {
    if (!schema) return {};
    const requestEntries = {};
    schema.forEach((schemaItem) => {
      const { name, data_type } = schemaItem;
      const assigned = assignedCSVIndexes.find(({ selectedSchemaName }) => selectedSchemaName === name);
      if (!ALLOWED_TYPES.includes(data_type)) return;
      if (assigned && assigned.index !== void 0) {
        let value = row[assigned.index];
        if (data_type === "checkbox") {
          if (typeof value === "string") {
            const lower = value.trim().toLowerCase();
            switch (lower) {
              case "true":
                value = true;
                break;
              case "false":
                value = false;
                break;
              default:
                value = null;
                break;
            }
          }
        } else if (data_type === "dropdown" || data_type === "category") {
          if (!isValidJSONObject(value)) return;
          value = JSON.parse(value);
        }
        requestEntries[name] = value;
      }
    });
    if (Object.values(requestEntries).every((x) => x === null || x === "" || x === void 0)) {
      throw new Error(`No values are assigned on row ${index + 1} of the file`);
    }
    return requestEntries;
  };
  const createRequestBody = (requestEntries, row) => ({
    category_value: {
      schema_attributes: requestEntries,
      ...useForPages && {
        url_slug: row[assignedURLSlug.indexOfCSV].toLowerCase().replace(/([\W])/g, "-").replace(/(-{2,})/g, "-")
      }
    }
  });
  const makeAPIRequest = async (requestBody) => {
    const fetchUrl = `${url}/${categoryID}/category_values${isOverwrite ? "/update_or_create" : ""}.json`;
    const response = await fetch(fetchUrl, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
      credentials: "same-origin"
    });
    if (!response.ok) throw new Error(`API Error: ${response.statusText}`);
    return response.json();
  };
  const importCategoryValues = async () => {
    try {
      setStep(2);
      setIsLoading(true);
      if (!uploadedFile) return;
      const results = await Promise.all(
        isNestedMode ? arrayToNestedCategories(
          uploadedFile ? uploadedFile.results.data : [],
          assignedParentIdentifier.indexOfCSV,
          assignedNestingIdentifier.indexOfCSV,
          assignedURLSlug.indexOfCSV,
          assignedCSVIndexes
        ).map(async (categoryValue, index) => {
          const requestBody = categoryValue;
          return makeAPIRequest(requestBody);
        }) : uploadedFile.results.data.slice(1).map(async (row, index) => {
          validateRow(row, index);
          const requestEntries = processRowData(row, index);
          const requestBody = createRequestBody(requestEntries, row);
          return makeAPIRequest(requestBody);
        })
      );
      setImportView(results);
    } catch (error2) {
      setImportView([
        {
          error: {
            description: "Import Error",
            details: [error2 instanceof Error ? error2.message : "Unknown error occurred"]
          }
        }
      ]);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!category) return;
    initializeCategoryContext(category);
  }, [category, initializeCategoryContext]);
  useEffect(() => {
    if (!uploadedFile) {
      setError("No file uploaded, please upload a file to continue");
      return;
    }
    if (!categoryContext) {
      setError("No category context found, please refresh the page and try again");
      return;
    }
    const identifierNotSelected = !assignedCSVIndexes.some((each) => each.selectedSchemaName.toLowerCase() === categoryContext.identifier.toLowerCase());
    if (identifierNotSelected) {
      setError(`Please assign a column to the identifier: ${categoryContext.identifier}`);
      return;
    }
    if (isNestedMode) {
      const nestedCatValuesPayload = arrayToNestedCategories(
        uploadedFile ? uploadedFile.results.data : [],
        assignedParentIdentifier.indexOfCSV,
        assignedNestingIdentifier.indexOfCSV,
        assignedURLSlug.indexOfCSV,
        assignedCSVIndexes
      );
      const hasNestedValues = nestedCatValuesPayload.some((each) => each.children);
      if (!hasNestedValues) {
        setError("Cannot import because the current selection has no nested values structure found for the platform to accept.");
        return;
      }
    }
    setError(null);
  }, [
    uploadedFile,
    categoryContext,
    isNestedMode,
    assignedNestingIdentifier.indexOfCSV,
    assignedParentIdentifier.indexOfCSV,
    assignedURLSlug.indexOfCSV,
    assignedCSVIndexes
  ]);
  return /* @__PURE__ */ jsxs6("div", { style: { ...commonStyles, gap: "3rem" }, children: [
    /* @__PURE__ */ jsx6(BetterUpload, {}),
    uploadedFile && /* @__PURE__ */ jsxs6("div", { style: { ...commonStyles, gap: "2rem" }, children: [
      /* @__PURE__ */ jsxs6("div", { className: "card", style: { display: "grid", gridTemplateColumns: "auto 1fr" }, children: [
        /* @__PURE__ */ jsxs6("div", { className: "p-5 d-flex flex-column justify-content-center gap-5", children: [
          /* @__PURE__ */ jsxs6("div", { className: "d-flex flex-column justify-content-center", children: [
            /* @__PURE__ */ jsxs6("div", { className: "form-check", children: [
              /* @__PURE__ */ jsx6("input", { className: "form-check-input", type: "checkbox", id: "overwrite-selector", onChange: () => setIsOverwrite(!isOverwrite) }),
              /* @__PURE__ */ jsx6("label", { className: "form-check-label muted", htmlFor: "flexCheckDefault", children: "Overwrite existing fields?" })
            ] }),
            /* @__PURE__ */ jsx6("p", { className: "text-muted mb-0", children: useForPages ? "Ticking this option will overwrite existing values with the same URL Slug" : `Ticking this option will overwrite existing values with the same identifier: ${categoryContext?.identifier}` })
          ] }),
          !!useForPages && /* @__PURE__ */ jsx6(URLSlugSelector, {}),
          !!isNested && /* @__PURE__ */ jsx6(ISNestedToggler, {})
        ] }),
        /* @__PURE__ */ jsxs6("div", { className: "d-flex p-5 flex-column gap-3 align-items-center justify-content-center border-start", children: [
          /* @__PURE__ */ jsx6("p", { className: `mb-0 ${error ? "text-danger" : "text-success"}`, children: error || "Ready to import" }),
          /* @__PURE__ */ jsx6("div", { children: /* @__PURE__ */ jsx6("button", { className: "btn btn-primary", disabled: !!error, onClick: importCategoryValues, children: "Import" }) })
        ] })
      ] }),
      step === 1 && /* @__PURE__ */ jsx6(StepOne, {}),
      step === 2 && /* @__PURE__ */ jsx6(StepTwo, {})
    ] })
  ] });
};
export {
  CSVParser
};
/*! Bundled license information:

papaparse/papaparse.min.js:
  (* @license
  Papa Parse
  v5.5.3
  https://github.com/mholt/PapaParse
  License: MIT
  *)
*/
//# sourceMappingURL=bundle.js.map
